// extracted by css-extract-rspack-plugin
export default {"cardWrap":"cardWrap-JRphoU","highlighted":"highlighted-NAa4CW","cardHeader":"cardHeader-CoZ2As","titleGroup":"titleGroup-OrmE9F","info":"info-b7FNwS","list":"list-Qb7tIn"};